<app-tips [matIcon]="matIcon" [bgColor]="bgColor" [txtColor]="txtColor">
  <ng-content></ng-content>
</app-tips>
